import { Component, ViewChild, OnInit } from "@angular/core";
/*
import { AngularFirestore } from "angularfire2/firestore";
import { AngularFireObject, AngularFireDatabase } from "angularfire2/database";
*/
import { Observable } from "rxjs";
declare var google: any;
import {
  GoogleMapsAPIWrapper,
  AgmMap,
  LatLngBounds,
  LatLngBoundsLiteral
} from "@agm/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RightinfoService } from "../../service/rightinfo.service";
import { element } from "protractor";
import { AwsService } from '../../providers/appsyncservice/aws.service';
import {InfoServiceService} from '../../service/rightinfo/info-service.service';

@Component({
  selector: "app-driverlistview",
  templateUrl: "./driverlistview.component.html",
  styleUrls: ["./driverlistview.component.css"]
})
export class DriverlistviewComponent implements OnInit {
  // @ViewChild('AgmMap') agmMap: AgmMap;
  markers = [];
  toltrips: any;
  usertrips: any;
  allusertrips: any;
  getusername: any;
  getmobileno: any;
  fullList: any;
  getAllList: any;
  tripID: any;
  dir = undefined;
  fulltrips: any;
  userList: any;
  userpos: any;
  allValues: any;
  myTrip: any;
  SingleTripList: any;
  filterList = new Set();
  mapdriverlist: any;

  driverName: any;
  drivermobile: any;
  numberplate: any;
  cablist: any;
  driverjson = [];
  userjson = [];
  currentLocation: String = "";

  triplist: any = {};

  zoom: number = 8;
  // initial center position for the map
  lat: number = 12.73377;
  lng: number = 80.011268;
  screen : String ;

  constructor(
    // public db: AngularFirestore,
    private route: ActivatedRoute,
    public router: Router,
    private rightinfoService: RightinfoService,
    public awserviceProvider: AwsService,
    private infoService : InfoServiceService
  ) {
    this.screen=infoService.getUrl();
    this.getTrip();
    // this.fulltrips = db.collection('UserTrips',ref => ref.orderBy('trip_id')).valueChanges()
    // this.fulltrips.subscribe(data => {
    //   this.userList = data
    //   console.log("this.fulltrips", this.userList)
    // });
    this.lat = 12.73377;
    this.lng = 80.011268;
  }

  mapReadyfn() {
    this.lat = 12.73377;
    this.lng = 80.011268;

  }

  ngOnInit(): void {
    this.lat = 12.73377;
    this.lng = 80.011268;

  }

  getTrip() {
    console.log(this.router.url);

    this.route.params.subscribe(params => {
      console.log("url driverlistview values ", params);
      if (params.trip_id === undefined) {
        return;
      }
      this.tripID = params.trip_id;
      var tripId = params.trip_id;
      // this.getUserList(tripId);
      var usertriplist: any[] = [];


      this.awserviceProvider.getScTripMasterById(tripId).then(trip => {

        console.log("2222222222222222222", trip)

        this.awserviceProvider.getRncUsers(trip.driver_id).then(driver => {
          trip.driver = {};
          trip.driver = driver;
        })

        // alert(trip.cab_id)
        this.awserviceProvider.getScCabMasterById(trip.cab_id).then(cab => {
          trip.cab = {};
          trip.cab = cab;
          console.log("222222", trip.cab)
        })
      // if(trip.status!=2){
        this.awserviceProvider.getScTripPosition(tripId).then(async data => {
          //  alert(data)
          console.log("DDDDDD", data)
          if (data != null) {
            this.userpos = data;
            var position = this.userpos.position;
            var last_element = position[position.length - 1];
            var marklat = last_element.lat;
            var marklng = last_element.long;
            let dateFormat = require('dateformat');
            let markertip=trip.cab.vehicle_no+"-"+(trip.trip_type==0?'Pick-up':'Drop')
   
            this.addMarkerDirTrip(markertip, marklat, marklng)
          }
          

        })
     // }
      

        this.awserviceProvider.getScUserTripUser(tripId).then(usertrips => {
          let usrtrips: any = this.sortinglist(usertrips);
          let triplist: any = [];
          

          usrtrips.forEach(usrtrip => {
            if (usrtrip.user_id == trip.driver_id) {
              trip.start_address = usrtrip.start_address.address;
              trip.end_address = usrtrip.end_address.address;
              this.getDirection(usrtrip.start_address, usrtrip.end_address);
            }
            else {
              this.awserviceProvider.getRncUsers(usrtrip.user_id).then(user => {
                usrtrip.user = {};
                usrtrip.user = user;
                triplist.push(usrtrip)
              })
            }
          });
          trip.usertrip = triplist;
        })

        this.triplist = trip;
        console.log(" this.triplist", this.triplist)

      });


    });
  }

  sortinglist(tripList) {
    const sorted = tripList.sort((t1, t2) => {
      const d1 = t1.drop_point;
      const d2 = t2.drop_point;
      if (d1 > d2) { return -1; }
      if (d1 < d2) { return 1; }
      return 0;
    });
    return sorted;
  }

  async getGeoAddress(lat, long): Promise<any> {
    let myPromise = await new Promise((resolve, reject) => {
      setTimeout(() => {
        let geocoder = new google.maps.Geocoder();
        var latlng = new google.maps.LatLng(lat, long);

        geocoder.geocode({ 'latLng': latlng }, function (results, status) {

          if (status == google.maps.GeocoderStatus.OK) {
            var address = results[1].formatted_address;
            resolve(address)
            // console.log('GeoLocation found')
          } else {
            // console.log("geo locaton status error--", status, results)
            reject(status)

          }
        });
      }, 2300);
    })
    return myPromise
  }


  getDirection(start, end) {
    // this.showdirection = true;
    // if(tripId != undefined){
    console.log("start-----------", start)
    console.log("start.lat-----------", start.lat)
    console.log("lng-----------", start.long)
    this.dir = {
      origin: { lat: start.lat, lng: start.long },
      destination: { lat: end.lat, lng: end.long }
    };
  }

  addMarkerDirTrip(fulltripId, marklat, marklng) {


    var marker = {
      lat: marklat,
      lng: marklng,
      iconUrl: "assets/images/cab.png",
      tripName: fulltripId
    };
    this.markers.push(marker);
    console.log("this.markers",this.markers);
  }
}
